// extracted by mini-css-extract-plugin
export default {"section":"Categories_section__PEGfr","list":"Categories_list__P8Qkt","item":"Categories_item__Ytwt3","image":"Categories_image__fDHU+","title":"Categories_title__NW54M"};